import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const DsTooltipDefaultProps = {
    arrow: true,
    placement: 'top-start',
    enterTouchDelay: 0,
    leaveTouchDelay: 4000,
    children: _jsx(_Fragment, {})
};
